import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

const LoginButton = () => {
  const { loginWithRedirect } = useAuth0();
  return <button onClick = {() => loginWithRedirect() }>Log In</button>;
};

const LogoutButton = () => {
  const { logout } = useAuth0();
  return <button onClick = {() => 
      logout({returnTo: window.location.origin })}>
    Log Out
  </button>;
};

const AuthStatus = (props) => {
  const {user, isAuthenticated, isLoading } = useAuth0(0);

  if (isLoading) {
    return <div>Loading Auth...</div>
  }

  if (isAuthenticated) { 
    return ( <div> logged in as {user.name} <br /> <LogoutButton /> </div>); 
  } else {
    return ( <div><LoginButton /></div>); 
  }

};

export{LoginButton, LogoutButton, AuthStatus}
